const EPICS_COUNT_BUCKETS = [0, 10, 20, 30, 50, 100, 200, 500];

/**
 * Bucket ranges:
 * `0 | 0_10 | 10_20 | 20_30 | 30_50 | 50_100 | 100_200 | 200_500 | 500+`
 * @param epicsCount Number of epics fetched
 * @returns Bucket range for the epics count
 */
export const mapEpicsCountToBucket = (epicsCount: number) => {
	if (epicsCount === 0) return '0';

	const bucketIndex = EPICS_COUNT_BUCKETS.findIndex((bucket) => epicsCount <= bucket);
	return bucketIndex >= 0
		? `${EPICS_COUNT_BUCKETS[bucketIndex - 1]}_${EPICS_COUNT_BUCKETS[bucketIndex]}`
		: '500+';
};
